import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-3 flex flex-col" }
const _hoisted_2 = { class: "flex relative font-bold bg-gray-100 dark:bg-gray-700 py-2 mb-3 rounded truncate" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-2 w-1/12 hidden sm:block" }, "Rank", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "px-2 flex-1" }, "Account", -1)
const _hoisted_5 = {
  key: 0,
  class: "px-2 w-3/12",
  style: {"min-width":"4em"}
}
const _hoisted_6 = {
  key: 1,
  class: "px-2 w-2/12",
  style: {"min-width":"4em"}
}
const _hoisted_7 = {
  key: 2,
  class: "px-2 w-3/12",
  style: {"min-width":"4em"}
}
const _hoisted_8 = { class: "flex flex-col divide-y divide-gray-100 dark:divide-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeaderboardRow = _resolveComponent("LeaderboardRow")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, { title: _ctx.title }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          (_ctx.records[0] && _ctx.records[0].balance !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Balance "))
            : _createCommentVNode("", true),
          (_ctx.records[0] && _ctx.records[0].score !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Score "))
            : _createCommentVNode("", true),
          (_ctx.records[0] && _ctx.records[0].number_of_transactions !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Number of Transactions "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records.slice(0, _ctx.limit), (record, i) => {
            return (_openBlock(), _createBlock(_component_LeaderboardRow, {
              key: record.account_id,
              record: record,
              rank: i + 1
            }, null, 8, ["record", "rank"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}